"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _uniqueId = _interopRequireDefault(require("transmute/uniqueId"));

var _TokenPlugin = _interopRequireDefault(require("../token/TokenPlugin"));

var _TokenResults = _interopRequireDefault(require("../token/TokenResults"));

var _TokenResultItem = _interopRequireDefault(require("../token/TokenResultItem"));

var _AtMentionInviteZeroState = _interopRequireDefault(require("./AtMentionInviteZeroState"));

var DEFAULT_OPTS = {
  trigger: '@',
  entityType: (0, _uniqueId.default)('ATMENTION'),
  dataProp: 'users',
  onInsertProp: 'onAtMention',
  useInviteZeroState: false,
  overlayPositioning: {
    placement: 'bottom right'
  },
  inviteZeroStateOpts: null,
  // Check AtMentionZeroState.js for options
  addTrailingSpace: true
};

var AtMentionPlugin = function AtMentionPlugin() {
  var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var optsWithDefaults = Object.assign({}, DEFAULT_OPTS, {}, opts);
  var useInviteZeroState = optsWithDefaults.useInviteZeroState,
      TokenResultsComponent = optsWithDefaults.TokenResultsComponent,
      inviteZeroStateOpts = optsWithDefaults.inviteZeroStateOpts;

  if (useInviteZeroState && !TokenResultsComponent) {
    if (inviteZeroStateOpts) {
      optsWithDefaults.TokenResultsComponent = (0, _TokenResults.default)(_TokenResultItem.default, (0, _AtMentionInviteZeroState.default)(inviteZeroStateOpts));
    } else {
      // eslint-disable-next-line no-console
      console.error('Must include inviteZeroStateOpts if using the invitation zero state.');
    }
  }

  return (0, _TokenPlugin.default)(optsWithDefaults);
};

var _default = function _default() {
  if (arguments.length === 0) {
    return AtMentionPlugin({});
  }

  return AtMentionPlugin.apply(void 0, arguments);
};

exports.default = _default;
module.exports = exports.default;